import { Flex, FlexProps } from '@chakra-ui/react';
import { forwardRef } from 'react';

export type QFlexProps = FlexProps;

export const QFlex = forwardRef<HTMLDivElement, QFlexProps>((props, ref) => (
  <Flex {...props} ref={ref} />
));
QFlex.displayName = 'QFlex';
